import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Particles from 'react-particles';
import { loadSlim } from 'tsparticles-slim';
import type { Engine } from 'tsparticles-engine';
import { ParticlesOptions } from '@/config/particles';
import LanguageSwitch from '@/components/LanguageSwitch';
import logo from '@/assets/q.svg';
import '../login/index.scss';
import { RouteConfig } from '@/types/route';
import PageTransition from '@/components/PageTransition';
import ConfigStore from '@/store/ConfigStore';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useLocale } from '@/hooks/useLocale';

export const routeConfig: RouteConfig = {
    title: '使用条款',
    // icon: <StopOutlined />,
    layout: false,
    
    // hidden: true // 在菜单中隐藏
}

const TermsPage: React.FC = () => {
    const { t } = useTranslation();
    const particlesInit = async (engine: Engine) => {
        await loadSlim(engine);
    };

    const TermsContent: React.FC = () => {
        const [termsHtml, setTermsHtml] = useState<string>('');
        const { currentLang } = useLocale(); // Get the current language from the LanguageSwitch
    
        useEffect(() => {
            // Determine the file path based on the selected language
            const filePath =
                currentLang === 'en-US'
                    ? '/src/assets/userTerms/QuBit用户协议_英文/user_terms_en.html'
                    : '/src/assets/userTerms/QuBit用户协议_简体中文2/user_term_cn.html';
    
            // Fetch the HTML content dynamically
            fetch(filePath)
                .then((response) => response.text())
                .then((data) => setTermsHtml(data))
                .catch((error) => console.error('Error loading terms content:', error));
        }, [currentLang]); // Re-run the effect when the language changes
    
        return (
            <div
                dangerouslySetInnerHTML={{ __html: termsHtml }}
            />
        );
    };

    // const TermsContent: React.FC = () => (
    //     <div
    //         style={{
    //             fontFamily: 'Arial, sans-serif',
    //             lineHeight: 1.6,
    //             maxWidth: '800px',
    //             margin: 'auto',
    //         }}
    //     >
    //         <h1 style={{ textAlign: 'center' }}>Terms of Use</h1>
    //         <p style={{ textAlign: 'center' }}>Last Updated: 16 June 2025</p>

    //         <p>
    //             Welcome to <strong>TGX LTD</strong>! These Terms of Use (“Terms”) govern your access to and use of the decentralized cryptocurrency exchange platform (the “Platform”) provided by <strong>TGX LTD</strong> (“we,” “us,” or “our”).
    //         </p>

    //         <p>
    //             Please read these Terms carefully before using the Platform. By accessing or using any part of the Platform, you agree to be bound by these Terms. If you do not agree to all the terms and conditions, you may not access the Platform.
    //         </p>

    //         <h2>1. Eligibility</h2>
    //         <p>
    //             You must be at least 18 years old and have the legal capacity to enter into these Terms. You may not use the Platform if you are a resident of any jurisdiction where the use of decentralized exchanges is prohibited or restricted.
    //         </p>

    //         <h2>2. No Custodial Services</h2>
    //         <p>
    //             <strong>TGX LTD</strong> is a non-custodial platform. We do not store, manage, or control users' funds, private keys, or wallets. You are solely responsible for managing your private keys and securing your wallet.
    //         </p>

    //         <h2>3. Use of the Platform</h2>
    //         <p>
    //             You agree to use the Platform in compliance with all applicable laws and regulations. You must not:
    //         </p>
    //         <ul style={{ marginLeft: '20px' }}>
    //             <li>- Use the Platform for illegal purposes, including money laundering or terrorist financing.</li>
    //             <li>- Attempt to interfere with or disrupt the Platform's operations.</li>
    //             <li>- Use any automated means to access the Platform without our prior permission.</li>
    //         </ul>

    //         <h2>4. Risk Acknowledgement</h2>
    //         <p>
    //             Cryptocurrency trading involves substantial risk. Prices can fluctuate significantly, and you may lose all or a substantial portion of your funds. By using the Platform, you acknowledge and accept these risks.
    //         </p>

    //         <h2>5. No Investment Advice</h2>
    //         <p>
    //             <strong>TGX LTD</strong> does not provide investment advice or recommendations. All content and tools on the Platform are for informational purposes only and should not be considered financial advice.
    //         </p>

    //         <h2>6. Limitation of Liability</h2>
    //         <p>
    //             To the fullest extent permitted by law, <strong>TGX LTD</strong> and its affiliates shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of the Platform.
    //         </p>

    //         <h2>7. Changes to Terms</h2>
    //         <p>
    //             We may update these Terms from time to time. Changes will be effective when posted. Continued use of the Platform after changes means you accept the revised Terms.
    //         </p>

    //         <h2>8. Governing Law</h2>
    //         <p>
    //             These Terms are governed by the laws of <strong>British Virgin Islands</strong>, without regard to conflict of law principles.
    //         </p>

    //         <h2>9. Governance Mechanisms</h2>
    //         <p>
    //             <strong>TGX LTD</strong> may implement community-based governance mechanisms to manage upgrades, parameter changes, or proposals affecting the Platform. These mechanisms may include, but are not limited to, on-chain voting, off-chain signaling, or DAO (Decentralized Autonomous Organization) participation.
    //         </p>

    //         <h3>9.1 Community Participation:</h3>
    //         <p>
    //            Eligible users (e.g., token holders) may participate in governance processes. Participation is optional but may influence the Platform's future direction.
    //         </p>
    //         <h3>9.2 No Guarantees:</h3>
    //         <p>
    //             While we aim for transparency, we do not guarantee all user interests will be represented. Decisions made through governance may be final and binding.
    //         </p>
    //         <h3>9.3 Token Utility:</h3>
    //         <p>
    //             Governance tokens may grant rights to vote or propose changes but do not represent ownership, profit-sharing, or equity rights in <strong>TGX LTD</strong>.
    //         </p>

    //         <h2>10. Dispute Resolution</h2>
    //         <h3>10.1 Informal Resolution: </h3>
    //         <p>
    //             You agree to contact <strong>TGX LTD</strong> at <strong>support@qb.finance</strong> to attempt to resolve disputes informally before taking further action.
    //         </p>
    //         <h3>10.2 Binding Arbitration:</h3>
    //         <p>
    //             If unresolved, any dispute shall be settled through binding arbitration under the rules of <strong>BVI International Arbitration Centre</strong> in <strong>British Virgin Islands</strong>. You waive any right to a jury trial or class action. The arbitrator’s decision is final and binding.
    //         </p>
    //         <h3>10.3 Exceptions:</h3>
    //         <p>
    //             Either party may seek injunctive relief in a court of law for intellectual property or unauthorized access issues.
    //         </p>
    //         <h3>10.4 Time Limit:</h3>
    //         <p>
    //             Any claim must be filed within one (1) year of occurrence, or it is permanently barred.
    //         </p>

    //         <h2>11. Contact</h2>
    //         <p>
    //             For any questions about these Terms, please contact us at: <strong>support@qb.finance</strong>.
    //         </p>
    //     </div>
    // );

    return (
        <PageTransition>
            <div className="term-page">
                <div className="term-container">
                    <Particles
                        className="absolute inset-0"
                        init={particlesInit}
                        options={ParticlesOptions}
                    />

                    <div className="absolute top-4 right-4 flex items-center space-x-3">
                        <LanguageSwitch />
                        <button
                            className="theme-switch"
                            onClick={() => ConfigStore.setThemeMode(ConfigStore.isDark ? 'light' : 'dark')}
                        >
                            {ConfigStore.isDark ? (
                                <SunOutlined className="text-amber-500" />
                            ) : (
                                <MoonOutlined className="text-blue-500" />
                            )}
                        </button>
                    </div>

                    <div
                        className="term-form-container"
                        style={{
                            maxHeight: '80vh', // Set maximum height
                            overflowY: 'auto', // Enable vertical scrolling
                        }}
                    >
                        <div className="header-section">
                            <img src={logo} alt="Logo" className="logo" />
                        </div>
                        <TermsContent />
                    </div>

                    <div className="copyright">
                        Copyright © {new Date().getFullYear()} QuBit Affiliate
                    </div>
                </div>
            </div>
        </PageTransition>
    );
};

export default TermsPage;
